import { execOnLoad } from '@general/helpers';
import { initPagination } from '@services/pagination';
import './search-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSearchPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  initPagination({
    callbacks: {
      afterFetch: ({ components: { contentWrapperEl } }) => {
        if (typeof window?.dAgency?.initProductTile === 'function')
          contentWrapperEl
            .querySelectorAll('.product-tile__container')
            .forEach((tile) => window.dAgency.initProductTile(tile));
      },
    },
  });
};

execOnLoad(window.dAgency.initSearchPage, '.search-page__section');
